import { Grid, Typography } from '@mui/material';
import { CustomDatePicker } from '@components/CustomDatePicker';
import { SubBar } from '@components/SubBar';
import { BasePage } from './BasePage';
import { useStyles } from './styles/BaseReportPage.styles';
import { useSelector } from 'react-redux';
import { ScrollToTop } from '@components/ScrollToTop';

import type { RootState } from '@features/redux/store';

interface BaseReportPageProps {
    children: React.ReactNode;
    title: string;
    dateRange?: { startDate: string; endDate: string };
    setDateRange?: (value: { startDate: string; endDate: string }) => void;
}

export const BaseReportPage = ({ children, dateRange, title, setDateRange }: BaseReportPageProps) => {
    const classes = useStyles();

    const { LastUpdated } = useSelector((state: RootState) => state.report);

    return (
        <BasePage>
            <SubBar className={classes.subMenuBar}>
                <Grid container display={'flex'} flex={1} flexDirection={'row'} alignContent={'center'}>
                    {dateRange && setDateRange && (
                        <Grid
                            item
                            xs={12}
                            xl={8}
                            lg={8}
                            md={12}
                            sm={12}
                            display={'flex'}
                            flex={1}
                            alignItems={'center'}>
                            <div className={classes.rangeDatePickerWrapper}>
                                <CustomDatePicker dateRange={dateRange} setDateRange={setDateRange} showSpan />
                            </div>
                        </Grid>
                    )}
                    <Grid
                        item
                        xs={12}
                        xl={4}
                        lg={4}
                        md={12}
                        sm={12}
                        display={'flex'}
                        flex={1}
                        alignItems={'center'}
                        className={classes.lastUpdatedTextWrapperContainer}>
                        <div className={classes.lastUpdatedTextWrapper}>
                            <Typography className={classes.lastUpdatedText}>Last updated {LastUpdated}</Typography>
                        </div>
                    </Grid>
                </Grid>
            </SubBar>

            <div className={classes.root}>
                <ScrollToTop />

                <Typography className={classes.title}>{title}</Typography>

                {children}
            </div>
        </BasePage>
    );
};
